<template>
    <div class='demo'>
      <video-player class="video-player vjs-custom-skin" v-if="curriculum_audio_detail.mates_type==2"
            ref="videoPlayer" 
            id="videoPlayer"
            :playsinline="true" 
            :options="playerOptions"
             @play="onPlayerPlay($event)"
             @pause="onPlayerPause($event)"
             @ready="playerReadied"
             @canplay="onPlayerCanplay($event)"
             @loadeddata="onPlayerLoadeddata($event)"
             @timeupdate="onPlayerTimeupdate($event)"
        >
      </video-player>
      <div class="page" style="padding: 20px;" >
         <van-button type="primary" block @click="bindChange('https://o-yzx.bysjy.com.cn/yxdczh0000000001/mates/202010/yxz5f83afbdc7b03.mp4')" >切换视频源1</van-button>
      </div>
      <div class="page" style="padding: 20px;" >
        <van-button type="primary" block @click="bindChange('https://o-yzx.bysjy.com.cn/yxdczh0000000001/mates/202009/yxz5f6055f116731.MP4')" >切换视频源2</van-button>
    </div>
    </div>
    
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import login from '@/components/common/login';
import VConsole from "vconsole";
var vConsole = new VConsole();

export default {
        name: "index",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                bodyShow: false,
                curriculum_audio_detail: [],
                playerOptions: {
                    playbackRates: [ 0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: true, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4", // 类型
                        src: '' // url地址
                    }],
                    src:"",
                    height:'',
                    poster : "", //你的封面地址
                    controls:true, // 是否显示控件
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                    }
                },
                setTimeFlag: 1,
                playtimes: 0, //视频观看起点
            }
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            },
        },
        created() {
            //console.log('this.$refs.videoPlayer.player created',this.$refs.videoPlayer);
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
        },
        
        mounted() {
            // this.util.hideOptionMenu()
            this.init()
            this.$(document).attr('title','测试')
            console.log("父组件")

            
            
            // console.log('this.$refs.videoPlayer.player1',this.$refs.videoPlayer);
            // this.onPlayerPlay(this.$refs.videoPlayer.player)
            
            if (typeof WeixinJSBridge == "undefined") { //屏蔽分享按钮
                console.log("undefined")
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
            } else {
                console.log("defined")
                this.onBridgeReady();
            }
            
            
        },
        methods:{
            init(){
                //this.getvideo()
            },
            bindChange(src){
                console.log('切换源',src)
                this.setTimeFlag = 1
                this.playerOptions.sources[0].src = src
                const myplayer =  this.$refs.videoPlayer.player
                this.playerOptions.poster = 'https://o-yzx.bysjy.com.cn/yxdczh0000000186/mates/202101/yxz6011010ee262a.png'
                //this.playtimes = 30
                //this.$refs.videoPlayer.player.play()
                
                let video = this.$refs.videoPlayer;
                video.player.pause()
                WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
                    console.log('getNetworkType微信回调了');
                    console.log('video.player', video.player);
                    //video.player.currentTime(33)
                    // document.querySelector('video').currentTime = 22
                    //video.player.play();//这里使用的是基于video.js的vue-player插件
                    // videoDom.play();
                });

               
                
            },
            onBridgeReady(){
                console.log("onBridgeReady")
                //const myplayer =  this.$refs.videoPlayer.player
                console.log('加载了微信，为啥还是没有播放',this.playtimes)
                this.getvideo()
                //自动播放
                //this.$refs.videoPlayer.player.play()
            },
            onPlayerPlay(player) {
                console.log('player play!', player)
                const myplayer =  this.$refs.videoPlayer.player
                console.log('player myplayer!', myplayer)
                //myplayer.play()
                
                console.log('更改播放位置呀')
                //document.querySelector('video').currentTime=15;
            },

            // 暂停回调
            onPlayerPause(player) {
                console.log('player pause!1111111111111111111111', player)
            },
            // 当前播放位置发生变化时触发。
            onPlayerTimeupdate(player) {
                console.log('onPlayerTimeupdate', player)
                if(this.setTimeFlag == 1){
                    //myPlayer[0].currentTime = lastCurrentTime;
                    player.currentTime(26)
                    this.setTimeFlag = 2;
                }
            },

            // 视频播完回调
            onPlayerEnded($event) {
                console.log(player)
            },

            // DOM元素上的readyState更改导致播放停止
            onPlayerWaiting($event) {
                console.log(player)
            },

            // 已开始播放回调
            onPlayerPlaying($event) {
                console.log(player)
            },

            // 当播放器在当前播放位置下载数据时触发
            onPlayerLoadeddata(player) {
                console.log("在这里设置下位置")
                //this.$refs.videoPlayer.player.play()
                //player.currentTime(25)
                //this.$refs.videoPlayer.player.currentTime(33)
            },

            

            //媒体的readyState为HAVE_FUTURE_DATA或更高
            onPlayerCanplay(player) {
                console.log("onPlayerCanplay可以播放了")
                
                // console.log('player Canplay!', player)
            },

            //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
            onPlayerCanplaythrough(player) {
            // console.log('player Canplaythrough!', player)
            },

            //播放状态改变回调
            playerStateChanged(playerCurrentState) {
                console.log('player current update state', playerCurrentState)
            },

            //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
            playerReadied(player) {
                console.log('example player 1 readied11111', player, this.playtimes);
                //player.currentTime(this.playtimes)
            },
            getvideo(){
                const _self = this
                this.util.server.mini_course.sections_detail({
                    data: {
                        sections_id: '6018f42424503'
                    },
                    callback: (res => {
                        
                        var data= res.data;
                        _self.curriculum_audio_detail=data;
                        //data.content = data.content.replace(/<img/gi,'<img style="max-width:100%;height:auto"');
                        this.playerOptions.sources[0].src=data.mates_path;
                        this.playerOptions.src =data.mates_path;
                        //document.querySelector("video").src  = data.mates_path;
                        this.playtimes = 20

                        let _this = this;
                        this.$nextTick(() => {
                            console.log(222);
                            //_self.$refs.videoPlayer.player.play()

                            let videoDom = document.querySelector("video")
                            let video = _this.$refs.videoPlayer;
                            /*
                            if(typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function"){
                                console.log('object3');
                                WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
                                    video.player.play();//这里使用的是基于video.js的vue-player插件
                                    console.log('play4');
                                    // videoDom.play();
                                });
                            }
                            */
                           console.log("WeixinJSBridge",WeixinJSBridge)
                           //WeixinJSBridge.invoke('getNetworkType', {},  this.onBridgeReady)
                            WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
                                console.log('getNetworkType微信回调了');
                                console.log('video.player', video.player);
                                video.player.play();//这里使用的是基于video.js的vue-player插件
                                // videoDom.play();
                            });
                        });
                        

                    })
                });
            }
            
        }
    }

</script>
